var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-body',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('b-button',{on:{"click":function($event){return _vm.callApi()}}},[_vm._v("call api")]),_c('p',[_c('b',[_vm._v("apiData:")]),_vm._v(" "+_vm._s(_vm.apiData))]),_c('hr')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }